// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1pvFZ","file":"styles_file__Mk3tD"};